module.exports = __webpack_public_path__ + "img/vitte-icon.ada79212.png";